<script>
import Spinner from 'shared/components/Spinner.vue';
import { useBranding } from 'shared/composables/useBranding';
import { mapGetters } from 'vuex';
import ModernLayout from '../../../components/Modern/ModernLayout.vue';
import SignupForm from './components/Signup/Form.vue';

export default {
  components: {
    SignupForm,
    Spinner,
    ModernLayout,
  },
  setup() {
    const { replaceInstallationName } = useBranding();
    return { replaceInstallationName };
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    isAChatwootInstance() {
      return this.globalConfig.installationName === 'Ruut';
    },
  },
  beforeMount() {
    this.isLoading = this.isAChatwootInstance;
  },
  mounted() {
    if (this.isLoading) {
      this.isLoading = false;
    }
  },
};
</script>

<template>
  <ModernLayout>
    <div v-show="!isLoading" class="flex h-full md:min-h-[100vh] items-center">
      <div
        class="flex-1 min-h-[640px] inline-flex items-center h-full justify-center overflow-auto py-6 md:py-6 py-4"
      >
        <div class="px-8 w-full max-w-none overflow-auto">
          <div class="mb-4">
            <h2 class="text-3xl font-medium text-left mb-7 text-white">
              {{ $t('REGISTER.TRY_WOOT') }}
            </h2>
          </div>
          <SignupForm />
          <div class="px-1 text-sm text-slate-300 mt-6 text-center">
            <span>{{ $t('REGISTER.HAVE_AN_ACCOUNT') }}</span>
            <router-link class="text-link text-white hover:text-slate-200" to="/app/login">
              {{ replaceInstallationName($t('LOGIN.TITLE')) }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isLoading" class="flex items-center min-h-screen justify-center w-full h-full">
      <Spinner color-scheme="primary" size="" />
    </div>
  </ModernLayout>
</template>
